<template lang="pug">
#sales-root
  .d-flex.w-100.h-100
    transition(name='sidenav-transition' mode='out-in')
      SideNav(
        v-if='currentRoute && currentRoute.name !== HOME_ROUTE_NAME'
        :rootPath='ROOT_PATH'
        :navItems='NAV_ITEMS'
        :currentRoute='currentRoute'
      )
    transition(name='router-transition' mode='out-in')
      router-view.main-router
</template>

<script>
/* eslint-disable no-console, global-require */
import SideNav from '@/components/SideNav.vue';

const ROOT_PATH = '/sales';
const HOME_ROUTE_NAME = 'sales.home';

export default {
  components: {
    SideNav,
  },
  data: () => ({
    currentRoute: null,

    ROOT_PATH,
    HOME_ROUTE_NAME,
    NAV_ITEMS: [
      {
        title: 'ทำรายการขาย',
        iconSrc: require('@/assets/sidenav/sidenav-item-new-order.svg'),
        to: `${ROOT_PATH}/new-order`,
      },
      {
        title: 'ประวัติการขาย',
        iconSrc: require('@/assets/sidenav/sidenav-item-history.svg'),
        to: `${ROOT_PATH}/history`,
      },
      {
        title: 'เป้าและค่าคอม',
        iconSrc: require('@/assets/sidenav/sidenav-item-goals.svg'),
        to: `${ROOT_PATH}/profile-performance`,
      },
      {
        title: 'ตั้งค่าส่วนตัว',
        iconSrc: require('@/assets/sidenav/sidenav-item-settings.svg'),
        to: `${ROOT_PATH}/settings`,
      },
    ],
  }),
  mounted() {
    this.currentRoute = this.$route;
  },
  watch: {
    $route(to) {
      // console.log(to);
      this.currentRoute = to;
    },
  },
};
</script>

<style lang="scss">
#sales-root {
  width: 100vw;
  height: 100vh;

  .main-router {
    // overflow: scroll;
    width: calc(100vw - #{$sidenav-width});
    flex: 1;
  }
}
</style>
